import Spinner from '@/components/Spinner'
import Counter from '@/components/Counter'
import ToggleSwitch from '@/components/ToggleSwitch'
import Title from '@/components/Title'
import BackButton from '@/components/BackButton'

export default {
    install (Vue) {
        Vue.component('Spinner', Spinner)
        Vue.component('Counter', Counter)
        Vue.component('Title', Title)
        Vue.component('BackButton', BackButton)
        Vue.component('ToggleSwitch', ToggleSwitch)
    }
}
